import {
    Button,
    Dialog,
    DialogActions,
    DialogBody,
    DialogContent,
    DialogSurface, DialogTitle,
    DialogTrigger,
    Spinner,
    Table, TableBody,
    TableCell,
    TableCellActions,
    TableHeader,
    TableHeaderCell,
    TableRow
} from "@fluentui/react-components";
import { DeleteFilled, DeleteRegular, EditFilled, EditRegular, bundleIcon } from "@fluentui/react-icons";
import axios from "axios";
import { useAuthState } from "react-firebase-hooks/auth";
import { useEffect, useState } from "react";
import { Base_Url, auth } from "../services/firebase";
import { CloseSVG, UserFormAddSVG } from "../static/svgs";
import useBreakpoint from "../hooks/useBreakpoint";
import '../components/Forms/FormStyle.css';
import eventDataService from "../services/eventDataService";
const EditIcon = bundleIcon(EditFilled, EditRegular);

const columns = [
    { columnKey: "firstName", label: "First Name" },
    { columnKey: "lastName", label: "Last Name" },
    { columnKey: "isAttending", label: "Is Attending" },
    { columnKey: "noOfGuest", label: "Guests" },
    { columnKey: "total", label: "Total" },
];
const waitcolumns = [
    { columnKey: "firstName", label: "First Name" },
    { columnKey: "lastName", label: "Last Name" },
    { columnKey: "isAttending", label: "Is Attending" },
    { columnKey: "noOfGuest", label: "Guests" },
    { columnKey: "total", label: "Total" },
];

function RSVPDialog(props) {

    const [totalAttending, setTotalAttending] = useState(0);
    const [maxAttending, setMaxAttending] = useState(0);
    const [rsvpsArr, setRsvpsArr] = useState([]);
    const [waitlistArr, setWaitlistArr] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const breakpoint = useBreakpoint();
    const isMobile = breakpoint === 'mobile';
    const DeleteIcon = bundleIcon(DeleteFilled, DeleteRegular);
    const [user, loading, error] = useAuthState(auth);

    useEffect(() => {
        if (props.selectedEvent && props.selectedEvent.rsvps) {
            const eventObj = props.selectedEvent;
            const eventDocId = eventObj.id;
            fetchEventDetails(eventDocId);
        } else {
            setRsvpsArr([])
            setWaitlistArr([])
            setTotalAttending(0)
        }
    }, [props.selectedEvent]);

    async function fetchEventDetails(eventId) {
        const docSnapshot = await eventDataService.getEvent(eventId);
        const rsvpsArray = docSnapshot.get("rsvps") || [];
        // ---- RSVPs ----
        if (rsvpsArray.length > 0) {

            // Combine filter + map + reduce into ONE loop
            let attendingArr = [];
            let totalGuests = 0;

            for (const rsvp of rsvpsArray) {
                if (rsvp.isAttending) {
                    const subtotal = (parseInt(rsvp.noOfGuest) || 0) + 1;
                    totalGuests += subtotal;

                    attendingArr.push({
                        ...rsvp,
                        subtotal
                    });
                }
            }

            if (attendingArr.length > 0) {
                attendingArr.push({
                    isGrandTotal: true,
                    firstName: "TOTAL:",
                    isAttending: "",
                    subtotal: totalGuests
                });

                setRsvpsArr(attendingArr);
                setTotalAttending(totalGuests);
                setMaxAttending(props.selectedEvent?.maximumAttendees);
            } else {
                setRsvpsArr([]);
                setTotalAttending(0);
            }
        } else {
            setRsvpsArr([]);
            setTotalAttending(0);
        }

        // ---- WAITLIST ----
        const waitlist = docSnapshot.get("rsvpWaitlist") || [];

        if (waitlist.length > 0) {
            setWaitlistArr(
                waitlist.map(item => ({
                    ...item,
                    subtotal: (parseInt(item.noOfGuest) || 0) + 1
                }))
            );
        } else {
            setWaitlistArr([]);
        }
    }

    // Promote a user from waitlist to RSVP (client-side update + backend call)
    async function promoteUserFromWaitlist(eventId, userId, force = false) {
        setIsLoading(true);
        try {
            const isoDateString = new Date().toISOString();
            const docSnapshot = await eventDataService.getEvent(eventId);
            const rsvpsArray = docSnapshot.get("rsvps") || [];
            const rsvpWaitlistArr = docSnapshot.get("rsvpWaitlist") || [];
            const maxAttendees = docSnapshot.get("maximumAttendees") || 0;

            const waitUserIndex = rsvpWaitlistArr.findIndex(w => w.userId === userId);
            if (waitUserIndex === -1) {
                alert("User not found in waitlist");
                setIsLoading(false);
                return;
            }

            const waitUser = rsvpWaitlistArr[waitUserIndex];


            let totalGuests = 0;
            for (const r of rsvpsArray) {
                if (r.isAttending) totalGuests += ((Number(r.noOfGuest || 0)) + 1);
            }

            const waitUserTotal = (Number(waitUser.noOfGuest || 0)) + 1;  // Total = guests + 1
            if (!force && totalGuests + waitUserTotal > maxAttendees) {
                alert(`Cannot move to RSVP. Capacity exceeded (current ${totalGuests}, adding ${waitUserTotal}, max ${maxAttendees}).`);
                setIsLoading(false);
                return;
            }

            // Build RSVP object to add/merge
            const newRsvp = {
                userId: waitUser.userId,
                isAttending: true,
                firstName: waitUser.firstName || "",
                lastName: waitUser.lastName || "",
                createdDate: isoDateString,
                noOfGuest: Number(waitUser.noOfGuest || 0),
                isFromAdmin: true,
            };

            const existingIndex = rsvpsArray.findIndex(r => r.userId === userId);
            if (existingIndex > -1) {
                const existing = rsvpsArray[existingIndex];
                // Sum guest counts instead of overwriting
                const existingGuests = Number(existing.noOfGuest || 0);
                const waitGuests = Number(newRsvp.noOfGuest || 0);
                const combinedGuests = existingGuests + waitGuests;

                rsvpsArray[existingIndex] = {
                    ...existing,
                    noOfGuest: combinedGuests,
                    isAttending: true,
                    updatedDate: isoDateString,
                };
                console.log(`Merged waitlist into RSVP for ${userId}: ${existingGuests} + ${waitGuests} => ${combinedGuests}`);
            } else {
                rsvpsArray.push(newRsvp);
            }

            const newWaitlist = rsvpWaitlistArr.filter(w => w.userId !== userId);

            try {
                const url = `${Base_Url}/promoteUserFromWaitlist?eventId=${eventId}&userId=${userId}`;
                console.log('Calling backend promote API with:', { eventId, userId, url });
                const config = {
                    method: 'get',
                    url,
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${user?.accessToken}`,
                    }
                };
                const resp = await axios.request(config);
                if (resp.status !== 200) console.warn('Backend promotion returned non-200', resp.status);
            } catch (e) {
                console.warn('Backend promote API failed (will still update client):', e?.message || e);
                if (e.response?.data) console.warn('Backend error response:', e.response.data);
            }

            // Update Firestore (client-side canonical state)
           try {
             const adata = rsvpsArray.filter((item) => item.isAttending).map(({ userId }) => userId);
            await eventDataService.updateEventFields(eventId, rsvpsArray, adata);
            await eventDataService.addWailitstMemberEventFields(eventId, newWaitlist);
           }
           catch(e)
            {
                console.error('Error updating Firestore after promotion:', e);
            }

            setIsLoading(false);
            props.updateGrid();
        } catch (error) {
            setIsLoading(false);
            console.error('Promotion error:', error);
            if (error?.response?.data?.error) alert(error.response.data.error);
        }
    }


    async function deleteFromWaitlist(eventId, userId, token) {
        try {
            setIsLoading(true);
            const url = `${Base_Url}/deleteWaitlistUser`;
            const data = {
                eventId: eventId,
                userId: userId
            };
            const config = {
                method: 'post',
                url,
                data,
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token || userId}`
                }
            };

            console.log("Request config:", config);

            const response = await axios.request(config);

            setIsLoading(false);
            props.updateGrid();

            if (response.status === 200) {
                console.log("User successfully deleted from waitlist:", response.data);
            } else {
                console.warn("Non-200 response from deleteFromWaitlist:", response.status, response.data);
            }
        } catch (error) {
            setIsLoading(false);
            if (error.response?.data?.error) {
                console.log(`Deletion failed: ${error.response.data.error}`);
            } else {
                console.log("Error response:", error.response || error);
            }
        }
    }

    //Action
    function onEditClick(rsvps) {
        props.onEditRsvpClick(rsvps)
    }

    function onWaitlistEditClick(rsvps) {
        props.onWaitlistClick(rsvps)
    }

    async function onMoveToRSVPClick(rsvp) {
        const eventId = props.selectedEvent.id; // or get from parent scope
        const userId = rsvp.userId;
        // Force promotion on click (allow move even if capacity exceeded)
        await promoteUserFromWaitlist(eventId, userId, true);
    }


    async function onDeleteRSVPClick(rsvp) {
        const eventId = props.selectedEvent.id; // or get from parent scope
        const userId = rsvp.userId;
        await deleteFromWaitlist(eventId, userId);
    }

    return (
        <Dialog
            open={props.open}
            onOpenChange={(event, data) => {
                props.setOpen(data.open);
            }}
        >
            <DialogSurface>
                <DialogBody>
                    <DialogTitle className={"d-flex justify-space-between custom-rsvp-dialog"}>
                        <div className={'pointer'} onClick={() => { onEditClick(null) }}>RSVPS({totalAttending}) <UserFormAddSVG /></div>
                        <div>
                            <DialogActions>
                                <DialogTrigger disableButtonEnhancement>
                                    <div className={"pointer"}><CloseSVG /></div>
                                </DialogTrigger>
                            </DialogActions>
                        </div>
                    </DialogTitle>

                    <DialogContent>
                        {props.selectedEvent && props.selectedEvent.rsvps &&
                            <div className={"table-layout"} style={{ marginTop: 24, ...(isMobile ? { border: 'none' } : {}) }}>
                                <Table aria-label="Table with cell actions">
                                    <TableHeader className={"list-row"}>
                                        <TableRow>
                                            {columns.map((column) => (
                                                <TableHeaderCell key={column.columnKey}>
                                                    <span className={"rsvps-header-typo"}>{column.label}</span>
                                                </TableHeaderCell>
                                            ))}
                                        </TableRow>
                                    </TableHeader>

                                    {isMobile ? (
                                        // Mobile: Render as vertical cards
                                        <tbody>
                                            {rsvpsArr.map((rsvps, index) => (
                                                rsvps.isGrandTotal ? (
                                                    // Only show TOTAL row as a simple line
                                                    <div className="rsvp-mobile-total-row" key={`total${index}`}>
                                                        <span className="rsvp-mobile-total-label">{rsvps.firstName}</span>
                                                        <span className="rsvp-mobile-total-value">{rsvps.subtotal}</span>
                                                    </div>
                                                ) : (
                                                    <div className="rsvp-mobile-card" key={`rsvp${index}`}>
                                                        <div className="rsvp-mobile-field">
                                                            <span className="rsvp-mobile-label">First Name:</span>
                                                            <span className="rsvp-mobile-value">{rsvps.firstName}</span>
                                                        </div>
                                                        <div className="rsvp-mobile-field">
                                                            <span className="rsvp-mobile-label">Last Name:</span>
                                                            <span className="rsvp-mobile-value">{rsvps.lastName}</span>
                                                        </div>
                                                        <div className="rsvp-mobile-field">
                                                            <span className="rsvp-mobile-label">Attending:</span>
                                                            {rsvps.isAttending === "" ? (
                                                                <span className="rsvp-mobile-value"></span>
                                                            ) : rsvps.isAttending ? (
                                                                <span className="rsvp-mobile-attending-free">Yes</span>
                                                            ) : (
                                                                <span className="rsvp-mobile-attending-no">No</span>
                                                            )}
                                                        </div>
                                                        <div className="rsvp-mobile-field">
                                                            <span className="rsvp-mobile-label">No. of Guests:</span>
                                                            <span className="rsvp-mobile-value">{rsvps.noOfGuest}</span>
                                                        </div>
                                                        <div className="rsvp-mobile-field">
                                                            <span className="rsvp-mobile-label">Subtotal:</span>
                                                            <span className="rsvp-mobile-value">{rsvps.subtotal}</span>
                                                        </div>
                                                        <div className="rsvp-mobile-field">
                                                            <Button
                                                                icon={<EditIcon />}
                                                                appearance="subtle"
                                                                aria-label="Edit"
                                                                onClick={() => onEditClick(rsvps)}
                                                            />
                                                        </div>
                                                    </div>
                                                )
                                            ))}
                                        </tbody>
                                    ) : (
                                        // Desktop: Render as table rows
                                        <TableBody>
                                            {rsvpsArr.map((rsvps, index) =>
                                                <TableRow key={`rsvp${index}`}>
                                                    {rsvps.isGrandTotal ?
                                                        <TableCell className={"rsvps-header-typo "}>{rsvps.firstName}</TableCell> :
                                                        <TableCell className={"rsvps-cell-typo "}>{rsvps.firstName}</TableCell>
                                                    }
                                                    <TableCell className={"rsvps-cell-typo "}>{rsvps.lastName}</TableCell>
                                                    <TableCell className={"rsvps-cell-typo "}>
                                                        <div className={rsvps.isAttending === "" ? "" : rsvps.isAttending ? "freeBox" : "priceBox"}>
                                                            {rsvps.isAttending === "" ? "" : rsvps.isAttending ? "Yes" : "No"}
                                                        </div>
                                                    </TableCell>
                                                    <TableCell className={"rsvps-cell-typo "}>{rsvps.noOfGuest}</TableCell>
                                                    {rsvps.isGrandTotal ?
                                                        <TableCell className={"rsvps-header-typo "}>{rsvps.subtotal}</TableCell> :
                                                        <TableCell className={"rsvps-cell-typo "}>
                                                            {rsvps.subtotal}
                                                            <TableCellActions>
                                                                <Button
                                                                    icon={<EditIcon />}
                                                                    appearance="subtle"
                                                                    aria-label="Edit"
                                                                    onClick={() => onEditClick(rsvps)}
                                                                />
                                                            </TableCellActions>
                                                        </TableCell>
                                                    }
                                                </TableRow>
                                            )}
                                        </TableBody>
                                    )}
                                </Table>
                            </div>
                        }
                        {
    props.selectedEvent && props.selectedEvent.rsvpWaitlist && props.selectedEvent.rsvpWaitlist.length > 0 ?
        <div style={{ marginTop: '20px', fontSize: '20px', fontWeight: 600 }} onClick={() => { onWaitlistEditClick(null) }}>
            Waitlist <UserFormAddSVG />
        </div> : null
}
                        {
                            isLoading ?
                                <Spinner label="Loading..." /> : <div></div>
                        }
                        {props.selectedEvent && props.selectedEvent.rsvpWaitlist && props.selectedEvent.rsvpWaitlist.length > 0 ?
                            <>
                                <div className={"table-layout"} style={{ marginTop: 8, border: isMobile ? 'none' : undefined }}>
                                    <Table aria-label="Table with cell actions">
                                        <TableHeader className={"list-row"}>
                                            <TableRow>
                                                {waitcolumns.map((column) => (  
                                                    <TableHeaderCell key={column.columnKey}>
                                                        <span className={"rsvps-header-typo"}>{column.label}</span>
                                                    </TableHeaderCell>
                                                ))}
                                            </TableRow>
                                        </TableHeader>
                                        {isMobile ? (
                                            <tbody>
                                                {waitlistArr && waitlistArr.map((rsvps, index) => (
                                                    <tr key={`rsvp${index}`}>
                                                        <div colSpan={5}>
                                                            <div className="waitlist-mobile-card">
                                                                <div className="waitlist-mobile-field">
                                                                    <span className="waitlist-mobile-label">First Name:</span>
                                                                    <span className="waitlist-mobile-value">{rsvps.firstName}</span>
                                                                </div>
                                                                <div className="waitlist-mobile-field">
                                                                    <span className="waitlist-mobile-label">Last Name:</span>
                                                                    <span className="waitlist-mobile-value">{rsvps.lastName}</span>
                                                                </div>
                                                                <div className="waitlist-mobile-field">
                                                                    <span className="waitlist-mobile-label">Status:</span>
                                                                    <span className="waitlist-mobile-value waitBox">Waiting</span>
                                                                </div>
                                                                <div className="waitlist-mobile-field">
                                                                    <span className="waitlist-mobile-label">No. of Guests:</span>
                                                                    <span className="waitlist-mobile-value">{rsvps.noOfGuest || 0}</span>
                                                                </div>
                                                                <div className="waitlist-mobile-field">
                                                                    <span className="waitlist-mobile-label">Subtotal:</span>
                                                                    <span className="waitlist-mobile-value">{((parseInt(rsvps.noOfGuest) || 0) + 1)}</span>
                                                                </div>
                                                                <div className="waitlist-mobile-field">

                                                                    <Button
                                                                        icon={<DeleteIcon />}
                                                                        appearance="subtle"
                                                                        aria-label="Delete"
                                                                        style={{ width: 40, height: 40, minWidth: 40, minHeight: 40, padding: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                                                                        onClick={() => onDeleteRSVPClick(rsvps)}
                                                                    />

                                                                    <Button className={"btnBorderOnly"} shape="circular" style={{ width: '140px' }} onClick={() => onMoveToRSVPClick(rsvps)}>
                                                                        Move to RSVP
                                                                    </Button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        ) : (
                                            <TableBody>
                                                {waitlistArr && waitlistArr.map((rsvps, index) =>
                                                    <TableRow key={`rsvp${index}`}>
                                                        <TableCell className={"rsvps-cell-typo "}>{rsvps.firstName}</TableCell>
                                                        <TableCell className={"rsvps-cell-typo "}>{rsvps.lastName}</TableCell>
                                                        <TableCell className={"rsvps-cell-typo "}>
                                                            <div className={"waitBox"}>{'Waiting'}</div>
                                                        </TableCell>
                                                        <TableCell className={"rsvps-cell-typo "}>{rsvps.noOfGuest || 0}</TableCell>
                                                        <TableCell className={"rsvps-header-typo "}>
                                                            {rsvps.subtotal}
                                                            <TableCellActions>
                                                                <div style={{ display: 'flex', alignItems: 'center', gap: '-4px' }}>
                                                                    <Button
                                                                        icon={<DeleteIcon />}
                                                                        appearance="subtle"
                                                                        aria-label="Delete"
                                                                        style={{ width: 40, height: 40, minWidth: 40, minHeight: 40, padding: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                                                                        onClick={() => onDeleteRSVPClick(rsvps)}
                                                                    />
                                                                    <Button
                                                                        className="btnBorderOnly"
                                                                        shape="circular"
                                                                        style={{ width: 140 }}
                                                                        onClick={() => onMoveToRSVPClick(rsvps)}
                                                                    >
                                                                        Move to RSVP
                                                                    </Button>
                                                                </div>
                                                            </TableCellActions>
                                                        </TableCell>
                                                    </TableRow>
                                                )}
                                            </TableBody>
                                        )}
                                    </Table>
                                </div>
                            </> :
                            <div></div>
                        }
                    </DialogContent>
                </DialogBody>
            </DialogSurface>
        </Dialog >
    )
}

export default RSVPDialog;